import Immutable from 'immutable';
import moment from 'moment';

import { translate } from 'sharedreact/utils/LanguageSupport';
import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  id: string,
  type: number,
  url: string,
  owner: string,
  sizeBytes: number,
  fileType: string,
  accessDate: moment.Moment | null,
  modificationDate: moment.Moment | null,
  creationDate: moment.Moment | null
} = {
  id: '',
  type: -1,
  url: '',
  owner: '',
  sizeBytes: 0, // size gives problems
  fileType: '',
  accessDate: null,
  modificationDate: null,
  creationDate: null
};

class SystemFileInfo extends Immutable.Record(Content) {
  static fromJS (json: object): SystemFileInfo {
    return ClassFactory.createFromJson(json, SystemFileInfo);
  }

  static get FileTypes () {
    return {DIRECTORY: 0, FILE: 1};
  }

  get folderName (): string {
    let folderName: string = '';
    const url: string = this.url != null ? this.url : '';
    let urlParts = url.split('/');
    if (this.type === SystemFileInfo.FileTypes.FILE) {
      if (urlParts.length > 1) {
        folderName = urlParts.slice(-2, -1).pop() ?? '';
      }
    } else if (this.type === SystemFileInfo.FileTypes.DIRECTORY) {
      folderName = urlParts.pop() ?? '';
      if (folderName.length === 0) {
        if (urlParts.length > 0) {
          folderName = urlParts.pop() ?? '';
        }
      }
    }
    try {
      folderName = decodeURIComponent(folderName);
    } catch (e) {
    }

    return folderName;
  }

  get fileName (): string {
    if (this.type === SystemFileInfo.FileTypes.FILE) {
      const url: string = this.url != null ? this.url : '';
      let fileName: string = url.split('/').pop() ?? '';
      try {
        fileName = decodeURIComponent(fileName);
      } catch (e) {
      }
      return fileName;
    }
    return '';
  }

  get fileTypeName (): string {
    switch (this.fileType) {
      case 'PDF': {
        return translate('workflowkits.product.fileinfo.filetype.pdf');
      }
      case 'PDFSC': {
        return translate('workflowkits.product.fileinfo.filetype.pdfsc');
      }
      default: {
        return this.fileType;
      }
    }
  }
}

export default SystemFileInfo;
